import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Button from '../elements/Button'
import DataSource from '../DataSource'
import InputRow from './InputRow'
import DataStore from '../DataStore'

const VerifyMobile = (props) => {
    const [isSent, setIsSent] = useState(false)
    const [isVerified, setIsVerified] = useState(false)
    const [requestError, setRequestError] = useState('')
    const [verifyError, setVerifyError] = useState('')
    const [verificationCode, setVerificationCode] = useState('')

    const handleChange = (e) => {
        setVerificationCode(e.target.value)
    }

    useEffect(() => {
        if (props.hasError) {
            setIsVerified(false)
            setVerificationCode('')
        }
    }, [props.hasError])

    const requestToken = event => {
        event.preventDefault()
        if (props.mobile && props.mobile.length > 0) {
            setRequestError('')
            setIsSent(false)
            DataSource.requestMobileToken(props.mobile.replaceAll(' ', ''))
                .then(response => {
                    setIsSent(true)
                })
                .catch(error => {
                    setRequestError('Oops, something went wrong, please check the mobile number you entered, and try again.')
                    setIsSent(false)
                })
        } else {
            setRequestError('Please enter your mobile number.')
        }
    }

    const verifyToken = event => {
        event.preventDefault()
        if (verificationCode) {
            const token = verificationCode
            setVerifyError('')
            setIsVerified(false)
            DataSource.verifyMobileToken(props.mobile.replaceAll(' ', ''), token)
                .then(() => {
                    setTimeout(() => {
                        // Slow down the verifying process, better user ux.
                        DataStore.setItem("verifiedMobileNumber", props.mobile.replaceAll(' ', ''))
                        setIsVerified(true)
                        props.handleVerified()
                    }, 500)
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        setVerifyError('Sorry the code you entered is incorrect, please try again.')
                    } else if (error.response.status === 429) {
                        setVerifyError('Sorry, too many attempts, please try again later')
                    } else {
                        setVerifyError('Oops, something went wrong, please try again.')
                    }
                })
        } else {
            setVerifyError('Please enter your verification code.')
        }
    }

    return (
        <React.Fragment>
            <div className='mb-2 mt-2 row align-items-center'>
                <div className='col-lg-8'>
                    <p className='m-0 mb-2 mb-lg-0 font-xsmall text-left text-lg-start'>To verify this transfer, we need to send a confirmation code via SMS <br /> to the mobile number above.</p>
                    {isSent && <div className='d-lg-none d-block mb-2'>
                        <p className='font-xsmall m-0 mb-1 bold color-lime'>A code has been sent to your number.</p>
                    </div>}
                </div>
                {requestError
                    ? <div className='col-lg-12 mt-3 d-block d-lg-none'>
                        <div className='row-error'>{requestError}</div>
                    </div>
                    : ''}
                <div className='col-lg-4 d-flex justify-content-lg-end confirmation-code-row'>
                    <Button action={requestToken} className='send-code-btn d-lg-block d-none'>Send code</Button>
                    <Button action={requestToken} className='send-code-btn d-block d-lg-none send-code-color-lime'>Send code</Button>
                    <div className='d-lg-none d-flex w-50 flex-1'>
                        <InputRow
                            name='code'
                            width={100}
                            placeholder='Enter the code here:'
                            handleChange={handleChange}
                            value={verificationCode}
                            hideLabel
                        />
                    </div>
                </div>
                <div className='col-lg-8 d-lg-none d-block mt-3'>
                    <Button action={verifyToken} className='send-code-btn verify-btn'>Verify code</Button>
                </div>

                {requestError
                    ? <div className='col-lg-12 mt-3 d-lg-block d-none'>
                        <div className='row-error'>{requestError}</div>
                    </div>
                    : ''}
            </div>
            {isSent
                ? <div className='row mb-3 align-items-center d-none d-lg-flex'>
                    <div className='col-lg-6'>
                        <p className='font-smaller m-0 mb-1 bold'>Code sent</p>
                        <p className='font-smaller m-0'>Please enter your confirmation code:</p>
                    </div>
                    <div className='col-lg-6 d-flex align-items-center'>
                        <div className='flex-grow-1'>
                            <InputRow
                                name='code'
                                placeholder='Confirmation code'
                                handleChange={handleChange}
                                value={verificationCode}
                                hideLabel
                            />
                        </div>
                        <div className='ml-3'>
                            <Button action={verifyToken} style={{ width: '85px', height: '45px' }}>Verify</Button>
                        </div>
                    </div>
                    {requestError
                        ? <div className='col-12 mt-3'>
                            <div className='row-error'>{requestError}</div>
                        </div>
                        : ''}
                    {verifyError
                        ? <div className='col-12 mt-3'>
                            <div className='row-error'>{verifyError}</div>
                        </div>
                        : ''}
                </div>
                : ''}
            {isVerified
                ? <div className='row mb-3'>
                    <div className='col-12'>
                        <p className='text-center form-success'>Your mobile number has been verified.</p>
                    </div>
                </div>
                : ''}
        </React.Fragment>
    )
}

VerifyMobile.propTypes = {
    mobile: PropTypes.string,
    handleVerified: PropTypes.func.isRequired
}

export default VerifyMobile



// WEBPACK FOOTER //
// ./resources/js/elements/VerifyMobile.js